import { NgTemplateOutlet } from '@angular/common';
import { AfterContentInit, Component, inject, TemplateRef, viewChild } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AppFooterComponent } from '@common/components/app-footer/app-footer.component';
import { AppHeaderComponent } from '@common/components/app-header/app-header.component';
import { RoutePath } from '@common/enums';
import { TemplateRegistryService, TemplateType } from '@common/services';
import { AuthContextService } from '@common/services/auth/auth-context.service';
import { I18NextPipe } from 'angular-i18next';
import { AlertContainerComponent, ToastComponent } from 'mbs-ui-kit';

const components = [AlertContainerComponent, AppHeaderComponent, AppFooterComponent, ToastComponent];
const directives = [NgTemplateOutlet, RouterLink, RouterOutlet];
const pipes = [I18NextPipe];

@Component({
  imports: [...components, ...directives, ...pipes],
  selector: 'app-layout',
  templateUrl: './app-layout.component.html'
})
export class AppLayoutComponent implements AfterContentInit {
  private readonly authContext = inject(AuthContextService);
  private readonly templateRegistry = inject(TemplateRegistryService);

  protected readonly RoutePath = RoutePath;
  protected readonly TemplateType = TemplateType;

  private backupTRef = viewChild.required('backupJobTransferredTRef', { read: TemplateRef<unknown> });
  private deleteTRef = viewChild.required('deleteJobTransferredTRef', { read: TemplateRef<unknown> });
  private exportTRef = viewChild.required('exportJobTransferredTRef', { read: TemplateRef<unknown> });
  private restoreTRef = viewChild.required('restoreJobTransferredTRef', { read: TemplateRef<unknown> });

  protected readonly prefix = this.authContext.prefix;

  ngAfterContentInit(): void {
    this.registerTemplate();
  }

  private registerTemplate(): void {
    const templates: [TemplateType, TemplateRef<unknown>][] = [
      [TemplateType.Backup, this.backupTRef()],
      [TemplateType.Delete, this.deleteTRef()],
      [TemplateType.Export, this.exportTRef()],
      [TemplateType.Restore, this.restoreTRef()]
    ];

    templates.forEach(([type, ref]) => this.templateRegistry.registerTemplate(type, ref));
  }
}
